import { z } from 'zod'

const apiEnvelopeSchema = z.object({
  success: z.boolean(),
  data: z.unknown(),
  time: z.number(),
})

export function parseApiData<Schema extends z.ZodType>(
  schema: Schema,
  response: unknown,
): z.output<Schema> {
  const envelope = apiEnvelopeSchema.parse(response)
  return schema.parse(envelope.data)
}
